module.exports = __webpack_public_path__ + "static/media/TeamViewer-Logo-light-1.b25acb25.svg";